import { ParamConfig, SelectOption } from '@diamond/shared/types';

export const mechanismOptions: SelectOption[] = [
  { value: 'discount_percentage', label: 'Diskon Persentase' },
  { value: 'discount_nominal', label: 'Diskon Nominal' },
  { value: 'free_goods', label: 'Free Goods' },
];
export const promoTypeOptions: SelectOption[] = [
  { label: 'Semua', value: '' },
  { label: 'Umum', value: 'general' },
  { label: 'Spesifik', value: 'specific' },
];

export const statusPromoOptions: SelectOption[] = [
  { label: 'Aktif', value: 'active' },
  { label: 'Tidak Aktif', value: 'inactive' },
  { label: 'Belum Aktif', value: 'not_yet_active' },
];

export const promoListSelectParamsConfig: ParamConfig = {
  mechanism: {
    isMulti: true,
    defaultValue: [],
    options: mechanismOptions,
  },
  promoType: {
    isMulti: false,
    defaultValue: '',
    options: promoTypeOptions,
  },
  statusPromo: {
    isMulti: false,
    defaultValue: 'active',
    options: statusPromoOptions,
  },
};
